export default [ // rating order configuration
    // "stationSurroundingAverage",
    "locationAverageRating",
    "equipementAverageRating",
    "surroundingsAverageRating",
    "valueForMoneyAverageRating",
]